/* PYNRS: collab video tiles.
   1. The overlay fades out while the tile's video plays and returns on pause/end.
   2. The embed and its player API are primed before any tap, so the theme's play() runs inside the tap
      gesture; phones then allow sound (the theme otherwise loads the Vimeo/YouTube script after the tap). */
(function () {
  var API = { vimeo: 'https://player.vimeo.com/api/player.js', youtube: 'https://www.youtube.com/iframe_api' };

  function loadScript(src) {
    if (document.querySelector('script[src="' + src + '"]')) return;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    document.head.appendChild(s);
  }

  function prime(media) {
    if (media.dataset.pynrsPrimed) return;
    media.dataset.pynrsPrimed = '1';
    var host = media.getAttribute('host');
    if (host === 'vimeo' && !(window.Vimeo && window.Vimeo.Player)) loadScript(API.vimeo);
    if (host === 'youtube' && !(window.YT && window.YT.Player)) loadScript(API.youtube);
    var template = media.querySelector('template');
    if (template && template.content && template.content.firstElementChild) {
      template.replaceWith(template.content.firstElementChild.cloneNode(true));
    }
  }

  function bind(tile) {
    var media = tile.querySelector('video-media');
    if (!media || media.dataset.pynrsBound) return;
    media.dataset.pynrsBound = '1';
    var on = function () { tile.classList.add('is-playing'); };
    var off = function () { tile.classList.remove('is-playing'); };
    media.addEventListener('media:play', on);
    media.addEventListener('media:pause', off);
    var video = media.querySelector('video');
    if (video) {
      video.addEventListener('play', on);
      video.addEventListener('pause', off);
      video.addEventListener('ended', off);
    }
    var play = tile.querySelector('.pynrs-collab__play');
    if (play) play.addEventListener('click', function () { prime(media); if (typeof media.play === 'function') media.play(); else media.click(); });
    if (media.hasAttribute('host')) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { prime(media); io.disconnect(); } });
        }, { rootMargin: '1200px 0px' });
        io.observe(media);
      } else {
        prime(media);
      }
    }
  }

  function init() { document.querySelectorAll('.pynrs-collab').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
